﻿import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [permissions, setPermissions] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [transportadoraBloqueada, setTransportadoraBloqueada] = useState(false);

  useEffect(() => {
    const verificaUsers = async () => {
      const typeUser = parseInt(localStorage.getItem("typeUser"));
      const userTypes = {
        125: { admin: true },
        150: { gGeral: true },
        200: { cliente: true },
        250: { clienteSup: true} ,
        300: { gate: true },
        320: { documental: true },
        340: { agendamento: true },
        350: { supDoc: true },
        400: { avaria: true },
        450: { supAva: true },
        500: { vistoria: true},
        520: { conferente: true },
        540: { oficina: true },
        550: { gerencPatio: true },
        1616: { dev: true },
      };
      const userTypeConfig = userTypes[typeUser] || {};
      setPermissions(userTypeConfig);

      // Verificar bloqueio de transportadora para clientes
      if (typeUser === 200 || typeUser === 250) {
        try {
          const idEnt = localStorage.getItem('idEnt');
          const token = localStorage.getItem('token');
          const operacionalURL = localStorage.getItem('urlOperacional');
          if (idEnt && token && operacionalURL) {
            const response = await axios.get(
              `${operacionalURL}get/transportadoras/validar-bloqueio/${idEnt}`,
              {
                headers: {
                  accept: 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            if (response.data.bloqueado) {
              setTransportadoraBloqueada(true);
            }
          }
        } catch (error) {
          console.error('Erro ao validar bloqueio da transportadora:', error);
        }
      }

      setLoaded(true);
    };
    verificaUsers();
  }, []);

  return (
    <AuthContext.Provider value={{ permissions, loaded, transportadoraBloqueada }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

